// export function debounce(fn, delay) {
// 	//防抖
// 	var delay = delay || 200;
// 	var timer;
// 	return function () {
// 		var th = this;
// 		var args = arguments;
// 		if (timer) {
// 			clearTimeout(timer);
// 		}
// 		timer = setTimeout(function () {
// 			timer = null;
// 			fn.apply(th, args);
// 		}, delay);
// 	};
// }
// 先执行后防抖
export function debounce(func, wait, immediate) {
	let timeout //计时器
	var wait = wait || 200;
	return function (...args) { //args就是传的参数
		let context = this
		if (timeout) clearTimeout(timeout) //如果有计时器就清除计时器
		if (immediate) { //如果立即执行设置为true
			let callNow = !timeout //定时器为空就是true
			timeout = setTimeout(function () { //开启定时器
				timeout = null
			}, wait) //wait：定时器的时间
			if (callNow) func.apply(context, args) //定时器为空的话就执行把传进来的函数指向改变为这个防抖函数，然后把参数传给这个防抖函数。通过return把参数返回。
		} else {
			//立即执行为false就开个定时器在执行这个函数
			timeout = setTimeout(function () {
				func.apply(context, args)
			}, wait)
		}
	}
}
// 节流
export function throttle(fn, interval) {
	var last;
	var timer;
	var interval = interval || 200;
	return function () {
		var th = this;
		var args = arguments;
		var now = +new Date();
		if (last && now - last < interval) {
			clearTimeout(timer);
			timer = setTimeout(function () {
				last = now;
				fn.apply(th, args);
			}, interval);
		} else {
			last = now;
			fn.apply(th, args);
		}
	}
}
